import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { expVal } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { useCanUpgradeForAllUsersInProduct } from '@confluence/experiment-mpucup-free-to-standard-feature-gates';
import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql';

export const useConfluenceMpucupStandardFgsExperimentAA = (skip?: boolean) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fgEnabled = Boolean(fg('conf-standard-fgs-for-mpucup-aa-gate'));
	const skipUpgradeHook = skip || !fgEnabled;

	const { error, canUpgradeAndPay } = useCanUpgradeForAllUsersInProduct(skipUpgradeHook);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);

		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'error',
				actionSubject: 'checkExperimentEligibility',
				source: 'useConfluenceMpucupStandardFgsExperimentAA',
				attributes: {
					error: error.message,
				},
			},
		}).fire();
	}

	if (fgEnabled && canUpgradeAndPay) {
		return {
			isEnrolled:
				expVal('conf-standard-fgs-for-mpucup-aa', 'cohort', 'not-enrolled') !== 'not-enrolled',
		};
	}

	return { isEnrolled: false };
};
